import { format, subDays } from 'date-fns';
import { GlobalSettingsModel } from 'models/Shared/GlobalSettingsModel';
import { DATE_FORMAT_API } from '../../../../../../../../@constants/date';
import { TrialBalanceReportFormModel } from '../../models';

export const getDefaultValues = (
  globalSettings: GlobalSettingsModel
): TrialBalanceReportFormModel => ({
  date: format(subDays(new Date(globalSettings?.frontend_date), 1), DATE_FORMAT_API),
  detailed: false,
  file_type: 'pdf',
});
